const BaseUrl =
"https://panel.whitelabelmd.com/totara/api/";
// const BaseUrl=
// "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/totara/api/";

export const products_url = BaseUrl + "get_products";
export const cheke_state = BaseUrl + "cheke_state";
export const add_user_check_product = BaseUrl + "createOrder_test";
export const createOrder_test_new = BaseUrl + "createOrder_test";
export const contact_details_step_25 = BaseUrl + "contact_details_step_25";
export const get_checkout_link_data = BaseUrl + "get_checkout_link_data";
export const get_product_details = BaseUrl + "get_product_details";
export const get_product_details_v3 = BaseUrl + "get_product_details_v3";
export const get_url_data = BaseUrl + "get_url_data";
export const createOrder_test = BaseUrl + "createOrder_test";
export const createOrder_stripe = BaseUrl + "createOrder_stripe";
export const createPaymentIntent_stripe = BaseUrl + "stripe/create-payment-intent";
export const check_coupons = "https://panel.whitelabelmd.com/wlmdbackend/api/check_coupons_v3";
export const SITE_ID = 395;
export const member_view = BaseUrl + "member_view";

export const PAP_ACCOUNT_ID =
  process.env.REACT_APP_PAP_ACCOUNT_ID || "default1";
export const PAP_TRACKING_SCRIPT_URL =
  process.env.REACT_APP_PAP_TRACKING_SCRIPT_URL ||
  "https://totarahealth.postaffiliatepro.com/scripts/jlhznh6xl";